import { Check } from '@griply/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';

import * as Styled from './calendar-sync-menu-items.style';

export type CalendarSyncMenuItemsProps = {
  isSynced: boolean;
  isHidden: boolean;
  onToggleSync: () => void;
  onToggleVisibility: () => void;
};

// The sync options themselves, so every surface offering them (the standalone
// sync menu, the timeslot context menu) can't end up with a different set. Each
// row reads as a toggle: the label states what the option does, the checkmark
// says whether it is on.
export const CalendarSyncMenuItems: React.FC<CalendarSyncMenuItemsProps> = ({
  isSynced,
  isHidden,
  onToggleSync,
  onToggleVisibility,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <PopupMenuListItem>
        <PopupMenuButton
          start={
            <Styled.CheckSlot $checked={isSynced}>
              <Icon icon={Check} strokeWidth={1.5} />
            </Styled.CheckSlot>
          }
          onClick={onToggleSync}
        >
          {t('calendar.event-sync.start')}
        </PopupMenuButton>
      </PopupMenuListItem>
      {isSynced && (
        <PopupMenuListItem>
          <PopupMenuButton
            start={
              <Styled.CheckSlot $checked={isHidden}>
                <Icon icon={Check} strokeWidth={1.5} />
              </Styled.CheckSlot>
            }
            onClick={onToggleVisibility}
          >
            {t('calendar.event-sync.hide-details')}
          </PopupMenuButton>
        </PopupMenuListItem>
      )}
    </>
  );
};
